/**
 * Generate a change log entry
 */
export function generateChangeLogEntry(number, user, action, target, details, metadata) {
    return {
        number,
        timestamp: new Date().toISOString(),
        user,
        action,
        target,
        details,
        metadata,
    };
}
/**
 * Format change log entries as a markdown table
 */
export function formatChangeLogTable(entries) {
    if (entries.length === 0)
        return '';
    const header = '| # | Timestamp | User | Action | Target | Details |';
    const separator = '|---|-----------|------|--------|--------|---------|';
    const rows = entries.map((e) => `| ${e.number} | ${e.timestamp} | ${e.user} | ${e.action} | ${e.target} | ${e.details} |`);
    return [header, separator, ...rows].join('\n');
}
/**
 * Append entries to an existing change log, returning a new array
 */
export function appendToChangeLog(existing, newEntries) {
    return [...existing, ...newEntries];
}
//# sourceMappingURL=changelog.js.map